<template>
    <div>
        <!-- 串關 -->
        <template v-if="(row['match_id'] && row['match_id'] == 29) || ((row['source_type'] == 'ob_sport' || row['source_type'] == 'im_sport' || row['source_type'] == 'ai_sport' || row['source_type'] == 'bc_sport') && row['serial_type'] != 1)">
            <span>{{ $t("column.saba.parlay") }}</span>
        </template>
        <template v-else-if="row['source_type'] == 'tg' || row['source_type'] == 'saba' || row['source_type'] == 'sabawhite_sport' || row['source_type'] == 'ob_sport' || row['source_type'] == 'im_sport' || row['source_type'] == 'ai_sport' || row['source_type'] == 'bc_sport'">
            <span :class="['text-' +  row.source_type]">{{ row["sport_name"] }}</span><br />
            <template v-if="Array.isArray(row['competition'])">
                <template v-for="(item,index) in row['competition']" >
                    <span  v-if="index==0" style="color: black" :key='index'>[{{ item }}]</span>
                    <span  v-else style="color: gray" :key='index'>({{ item }})</span><br :key='index'>
                </template>
            </template>
            <template  v-else-if="row.competition != '' && row.competition != null">
                <span style="color: black">[{{ row['competition'] }}]</span><br>
            </template>
            <template  v-if="row.team1 && row.team1 != ''">
                <span  ><i class="tg-icon tg-icon-grayball"></i>{{ row["team1"] }}</span><br>
            </template>
            <template  v-if="row.team2 && row.team2 != ''">
                <span  ><i class="tg-icon tg-icon-grayball"></i>{{ row["team2"] }}</span><br>
            </template>
        </template>
        <template v-else-if="row['source_type'] == 'sgwin_lottery' || row['source_type'] == 'ob_lottery'">
            <span :class="['text-' +  row.source_type]">{{ row["gameName"] }}</span><br />
            <template  v-if="row.eventId != '' && row.eventId != null">
                <span style="color: black">[{{ row['eventId'] }}]</span><br>
            </template>

            <template v-if="row.selection != ''" >
                <span class="text-green" >{{ row["selection"] }}</span><br>
            </template>

            <!-- 雙贏彩票的特有欄位 -->
            <template v-if="row.bet_code" >
                <span class="text-green" >[{{ row["betCode"] }}]</span><br>
            </template>

            <!-- OB彩票的特有欄位 -->
            <template v-if="row.bet_content" >
                <span class="text-green" >[{{ row["bet_content"] }}]</span>
            </template>

            <div>
                <span>@</span>
                <span class="text-red">{{ row["odds"] }}</span>
            </div>
        </template>
        <!-- WM真人、OB棋牌 -->
        <template v-else>
            <span :class="['text-' +  row.source_type]">{{ row["gameName"] }}</span><br />
            <template  v-if="row.eventId != '' && row.eventId != null">
                <span style="color: black">[{{ row['eventId'] }}]</span><br>
            </template>

            <template v-if="row.selection != ''" >
                <span class="text-green" >{{ row["selection"] }}</span>
            </template>
            
            <!-- wm_casino的項目 免傭 -->
            <template  v-if="row.commission == 1">
                <span class="text-green" >({{ $t("column.wm_casino.no_commission") }})</span>
            </template>

            <!-- ob_poker的項目 活動 -->
            <template  v-if="row.game_flag == 1">
                <span class="text-green" >({{ $t("column.ob_poker.activity") }})</span>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        row: Object,
    },
};
</script>
